import FeePotential from "./FeePotential";

export default FeePotential;
